<div class="game-stat" *ngIf="game && statistic">
  <div class="stats-values">
    <div class="stat-row">
      <div class="value">{{ statistic.team.shots || 0 }}</div>
      <div class="name">Удары</div>
      <div class="value">{{ statistic.competitorTeam.shots || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.shotsOnGoal || 0 }}</div>
      <div class="name">Удары в створ</div>
      <div class="value">{{ statistic.competitorTeam.shotsOnGoal || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.goalsPercent || 0 }}%</div>
      <div class="name">Процент реализации</div>
      <div class="value">{{ statistic.competitorTeam.goalsPercent || 0 }}%</div>
    </div>

    <div class="stat-row">
      <div class="value">{{ statistic.team.fouls || 0 }}</div>
      <div class="name">Фолы</div>
      <div class="value">{{ statistic.competitorTeam.fouls || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.yellowCards || 0 }}</div>
      <div class="name">Желтые карточки</div>
      <div class="value">{{ statistic.competitorTeam.yellowCards || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.redCards || 0 }}</div>
      <div class="name">Красные карточки</div>
      <div class="value">{{ statistic.competitorTeam.redCards || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.steals || 0 }}</div>
      <div class="name">Перехваты</div>
      <div class="value">{{ statistic.competitorTeam.steals || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.losses || 0 }}</div>
      <div class="name">Потери</div>
      <div class="value">{{ statistic.competitorTeam.losses || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.corners || 0 }}</div>
      <div class="name">Угловые</div>
      <div class="value">{{ statistic.competitorTeam.corners || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.saves || 0 }}</div>
      <div class="name">Сейвы вратарей</div>
      <div class="value">{{ statistic.competitorTeam.saves || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.savesPercent || 0 }}%</div>
      <div class="name">Процент сейвов</div>
      <div class="value">{{ statistic.competitorTeam.savesPercent || 0 }}%</div>
    </div>
  </div>
</div>
